// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class InstrumentBalancer {
    constructor(inst) {
        this.prices = [];
        this.accountListPrices = {};
        this.AccountTotalPositionAmount = new Map();
        this.AccountPositionPriceMultiplyAmountBuy = new Map();
        this.AccountPositionPriceMultiplyAmountSell = new Map();
        this.AccountPositionAmountBuy = new Map();
        this.AccountPositionAmountSell = new Map();
        this.AccountTotalProfitLoss = new Map();
        this.instrument = inst;
    }
    Add(pos) {
        var _a;
        if (pos != null) {
            this.prices.push(pos.Price);
            if ((_a = pos.Account) === null || _a === void 0 ? void 0 : _a.AcctNumber) {
                let accPrices = [];
                if (this.accountListPrices[pos.Account.AcctNumber] != null &&
                    Array.isArray(this.accountListPrices[pos.Account.AcctNumber])) {
                    accPrices = this.accountListPrices[pos.Account.AcctNumber];
                }
                else {
                    this.accountListPrices[pos.Account.AcctNumber] = accPrices;
                }
                accPrices.push(pos.Price);
            }
        }
    }
}
export class UserBalancer {
    constructor(account) {
        this.AssetBalances = {}; // new Dictionary<string, UserBalancesAssetBalanceFields>();
        this.Profit = 0;
        this.ProfitNet = 0;
        this.ProfitForMargin = 0;
        this.ProfitForUnsettled = 0;
        this.OnlyProfitForWithdrawalAvailable = 0;
        this.LossForUnsettled = 0;
        // Валюта сервера
        this.ProfitBase = 0;
        this.ProfitNetBase = 0;
        this.OpenPosAmount = 0.0;
        this.OpenOrdAmount = 0.0;
        this.DictPosInstrVal = {}; // new Dictionary<IInstrument, double>();
        this.OpenPosNumber = 0;
        this.OpenOrdNumber = 0;
        this.totalPositionAmount = 0;
        this.NotIsOptionCount = 0;
        this.WithdrawalAvailable = 0.0;
        this.BlockedForStocksAccountCurrency = 0.0;
        this.StockValue = 0;
        this.OptionValue = 0;
        this.PositionsValue = 0;
        this.fixedIncomeValue = 0;
        this.positions = [];
        this.Account = account;
    }
}
export class UserBalancesAssetBalanceFields {
    constructor() {
        this.OpenPosNumber = 0;
        this.OpenOrdNumber = 0;
    }
}
